import React, { forwardRef } from 'react';
import cn from 'classnames';
import Tooltip from 'components/shared/Tooltip';

/*::
type Props = {
  children?: any,
  className?: string,
  disabled?: boolean,
  loading?: boolean,
  onClick?: () => {},
  submit?: boolean,
}
*/

const IconButton = forwardRef(
  (
    {
      tooltip,
      children,
      className,
      disabled,
      loading,
      onClick,
      submit,
      tooltipProps,
      ...buttonProps
    } /*: Props */,
    ref,
  ) => {
    const hasClassName = !!className;

    const buttonClassName = cn('IconButton', {
      'IconButton-disabled': disabled,
      [className]: hasClassName,
    });

    const buttonContent = (
      <button
        disabled={disabled}
        className={buttonClassName}
        ref={ref}
        // eslint-disable-next-line react/button-has-type
        type={submit ? 'submit' : 'button'}
        onClick={onClick}
        {...buttonProps}
      >
        {children}
      </button>
    );

    if (tooltip && !disabled) {
      return (
        <div className="d-f">
          <Tooltip text={tooltip} className="fz-14" {...tooltipProps}>
            {buttonContent}
          </Tooltip>
        </div>
      );
    }

    return buttonContent;
  },
);

export default IconButton;
